var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"block text-lg font-medium leading-5 text-darkBlue tracking-wider"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }